import React, { useEffect, useState } from 'react';
import { firestore } from '../contexts/FirebaseContext';
import useAuth from './useAuth';

function useWalletVerif(userId) {
  const [walletExist, setWalletExist] = useState(false);
  const [userWallet, setUserWallet] = useState({});
  const [loadingWallet, setLoadingWallet] = useState(true);

  const { isAuthenticated } = useAuth();

  useEffect(() => {
    function getUserWallet() {
      firestore
        .collection('wallets')
        .doc(userId)
        .onSnapshot((doc) => {
          if (doc.exists) {
            setWalletExist(true);
            setUserWallet(doc.data());
            setLoadingWallet(false);
          } else {
            setWalletExist(false);
            setLoadingWallet(false);
          }
        });
    }
    if (isAuthenticated) {
      getUserWallet();
    }
  }, [isAuthenticated, userId]);

  return { walletExist, userWallet, loadingWallet };
}

export default useWalletVerif;
